import React from 'react';
import { Button, Container, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { userActions } from 'actions/userActions';
import logo from 'static/media/forest_x_color.svg';
import 'translations/translations';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: '8%',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '25rem',
    margin: 'auto',
    padding: '1.8rem 3.125rem',
  },
  img: {
    maxWidth: '18rem',
    marginBottom: '2rem',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(6, 0, 1, 0),
    paddingRight: theme.spacing(5),
    paddingLeft: theme.spacing(5),
    color: '#fff',
    fontWeight: 'bold',
  },
  error: {
    color: theme.palette.error.main,
    textAlign: 'right',
    fontSize: '0.8rem',
  },
  alignRight: {
    textAlign: 'right',
  },
  alignCenter: {
    textAlign: 'center',
  },
}));

const NotAuthorized = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { t } = useTranslation(['translations']);

  return (
    <Container className={classes.container}>
      <Paper className={classes.paper}>
        <img src={logo} alt="Logo" className={classes.img} />

        <Typography variant="h4">{t('validation.no_access')}</Typography>

        <Button
          variant="contained"
          color="primary"
          disableElevation
          onClick={() => {
            dispatch(userActions.logout());
          }}
        >
          {t('login_page.log_out')}
        </Button>
        <Button
          variant="contained"
          color="secondary"
          disableElevation
          onClick={() => {
            history.back();
          }}
        >
          {t('common.go_back')}
        </Button>
      </Paper>
    </Container>
  );
};

export { NotAuthorized };
